import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const useStyles = makeStyles(theme => ({
    button: {
        marginTop: theme.spacing(2),
    },
}));

const NotFound : React.FC = () => {
    const classes = useStyles();

    return (
        <>
            <Typography variant="h4">Page not found</Typography>
            <Typography variant="body1">
                The requested page could not be found.
            </Typography>
            <Button
                variant="contained"
                className={classes.button}
                onClick={() => window.location.href = '/'}
            >
                Return home
            </Button>
        </>
    );
};

export default NotFound;
